export const ICONS = {
    HOME: "home.svg",
    TAGS: "tags.svg",
    TEMPLATES: "templates.svg",
    HELP: "help.svg",
    SUPPORT: "contact_support.svg",
    FORMS: "add_form.svg",
    SETTINGS: "settings.svg",
    DESIGN: "design.png",
    MOBILE: "mobile_mode.svg",
    LAPTOP: "laptop_mode.svg",
    PREVIEW_STOP: "close.svg",
    PREVIEW_RESTART: "restart.svg",
    PREVIEW_NEXT: "next.png",
    PREVIEW_PREV: "prev.svg",
    COMMENT_OFF: "comment_off.svg",
    COMMENT_ON: "comment_on.svg",
    DOWNLOAD: "download.svg",
    DELETE: "delete.svg",
    ADD: "add.svg",
    EDIT: "edit.svg",
    PREVIEW: "preview.svg",
    RESPONSES: "responses.svg",
    SHARE: "share.svg",
    PUBLISH: "publish.svg",
    CHECKBOX: "checkbox.svg",
    ARROW: "arrow.png",
    UP: "up.svg",
    DOWN: "down.svg",
    CHECK: "check.svg",
    SWITCH_WORKSPACE: "switch.svg",
    ADD_WORKSPACE: "add_workspace.png",
}

export const EFFNO_LOGO = {
    REGULAR: "/logos/effno_logo_new.png",
}

